import { render, staticRenderFns } from "./scanCodeDetail.vue?vue&type=template&id=2c815e92&"
import script from "./scanCodeDetail.vue?vue&type=script&lang=js&"
export * from "./scanCodeDetail.vue?vue&type=script&lang=js&"
import style0 from "./scanCodeDetail.vue?vue&type=style&index=0&id=2c815e92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports